(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const update = () => {
      document.querySelectorAll('[data-header]').forEach((header) => {
        header.classList.toggle('is-scrolled', window.scrollY > 40);
      });
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-page')) {
    customElements.define(
      'product-page',
      class extends HTMLElement {
        connectedCallback() {
          const json = this.querySelector('[data-product-json]');
          this.variants = json ? JSON.parse(json.textContent) : [];
          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-option-index]')) this.onOptionChange();
          });
          const guide = this.querySelector('[data-size-guide]');
          this.querySelector('[data-size-guide-open]')?.addEventListener('click', () => guide?.showModal());
          this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => guide?.close());
          guide?.addEventListener('click', (event) => {
            if (event.target === guide) guide.close();
          });
        }
        onOptionChange() {
          const selected = [...this.querySelectorAll('[data-option-index]:checked')].map((input) => input.value);
          selected.forEach((value, index) => {
            const label = this.querySelector(`[data-option-value="${index}"]`);
            if (label) label.textContent = value;
          });
          const variant = this.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
          const button = this.querySelector('[data-add-button]');
          const idInput = this.querySelector('[data-variant-id]');
          if (!variant) {
            button.disabled = true;
            button.textContent = window.ROS_STRINGS?.unavailable || 'Unavailable';
            return;
          }
          idInput.value = variant.id;
          button.disabled = !variant.available;
          button.textContent = variant.available
            ? window.ROS_STRINGS?.addToCart || 'Add to bag'
            : window.ROS_STRINGS?.soldOut || 'Sold out';
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
          this.refreshPrice(url);
          if (variant.featured_media) {
            const media = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
            media?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        }
        async refreshPrice(url) {
          const sectionUrl = new URL(url);
          sectionUrl.searchParams.set('section_id', this.dataset.section);
          const html = await fetch(sectionUrl).then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-price]');
          const current = this.querySelector('[data-price]');
          if (fresh && current) current.replaceWith(fresh);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
